import React, { Component } from 'react'
import Modal from '../../../Modal'

export default class Colour extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: props.show,
      selectedColor: props.selectedColor,
      items: [
        { id: 1, value: 'rgba(255,12,12, 1)' },
        { id: 2, value: 'rgba(255,128,12, 1)' },
        { id: 3, value: 'rgba(255,184,3,1)' },
        { id: 4, value: 'rgba(39,220,90,1)' },
        { id: 5, value: 'rgba(12,255,240, 1)' },
        { id: 6, value: 'rgba(55,87,255, 1)' },
        { id: 7, value: 'rgba(195,0,226, 1)' },
        { id: 8, value: 'rgba(255,12,99, 1)' },
      ],
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  render() {
    let { items, selectedColor } = this.state

    return (
      <Modal
        className="p-colour p-btm"
        show={this.state.show}
        onHide={() => {
          this.props.onHide()
        }}
      >
        <>
          Colours
          <div className="colours">
            <div className="d-flex flex-nowrap justify-content-center">
              {items.map((item) => (
                <div key={item.id}>
                  <a
                    href="javascript:void(0)"
                    className={`colour ${
                      selectedColor?.id === item.id ? 'active' : ''
                    }`}
                    onClick={() => {
                      this.props.onColorSelected(item)
                      this.props.onHide()
                    }}
                    style={{
                      backgroundColor: `${item.value}`,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </>
      </Modal>
    )
  }
}
